import {
  useMutation,
  useQuery
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  ApiVerifyUserEmailParams,
  BackendErrorEntity,
  LoginDto,
  LoginEntity,
  OtpDto,
  ResendCustomerWelcomeEmailBodyDto,
  ResendCustomerWelcomeEmailResponseDto,
  SendUserOtpBodyDto,
  UserEntity,
  UserSignupBodyDto,
  VerifyUserEmailResponseDto,
  VerifyUserOtpBodyDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiLogin = (
    loginDto: MaybeRef<LoginDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      loginDto = unref(loginDto);
      
      return fetchApiInstance<LoginEntity>(
      {url: `/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginDto
    },
      options);
    }
  


export const getApiLoginMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiLogin>>, TError,{data: BodyType<LoginDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiLogin>>, TError,{data: BodyType<LoginDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiLogin>>, {data: BodyType<LoginDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiLogin(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiLoginMutationResult = NonNullable<Awaited<ReturnType<typeof apiLogin>>>
    export type ApiLoginMutationBody = BodyType<LoginDto>
    export type ApiLoginMutationError = ErrorType<BackendErrorEntity>

    export const useApiLogin = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiLogin>>, TError,{data: BodyType<LoginDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiLogin>>,
        TError,
        {data: BodyType<LoginDto>},
        TContext
      > => {

      const mutationOptions = getApiLoginMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiAdminLogin = (
    loginDto: MaybeRef<LoginDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      loginDto = unref(loginDto);
      
      return fetchApiInstance<LoginEntity>(
      {url: `/auth/admin/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginDto
    },
      options);
    }
  


export const getApiAdminLoginMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminLogin>>, TError,{data: BodyType<LoginDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminLogin>>, TError,{data: BodyType<LoginDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminLogin>>, {data: BodyType<LoginDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminLogin(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminLoginMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminLogin>>>
    export type ApiAdminLoginMutationBody = BodyType<LoginDto>
    export type ApiAdminLoginMutationError = ErrorType<BackendErrorEntity>

    export const useApiAdminLogin = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminLogin>>, TError,{data: BodyType<LoginDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiAdminLogin>>,
        TError,
        {data: BodyType<LoginDto>},
        TContext
      > => {

      const mutationOptions = getApiAdminLoginMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @deprecated
 * @summary Deprecated: Use POST /auth/sendOtp instead
 */
export const apiResendWelcomeEmail = (
    resendCustomerWelcomeEmailBodyDto: MaybeRef<ResendCustomerWelcomeEmailBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      resendCustomerWelcomeEmailBodyDto = unref(resendCustomerWelcomeEmailBodyDto);
      
      return fetchApiInstance<ResendCustomerWelcomeEmailResponseDto>(
      {url: `/auth/resendWelcomeEmail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resendCustomerWelcomeEmailBodyDto
    },
      options);
    }
  


export const getApiResendWelcomeEmailMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiResendWelcomeEmail>>, TError,{data: BodyType<ResendCustomerWelcomeEmailBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiResendWelcomeEmail>>, TError,{data: BodyType<ResendCustomerWelcomeEmailBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiResendWelcomeEmail>>, {data: BodyType<ResendCustomerWelcomeEmailBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiResendWelcomeEmail(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiResendWelcomeEmailMutationResult = NonNullable<Awaited<ReturnType<typeof apiResendWelcomeEmail>>>
    export type ApiResendWelcomeEmailMutationBody = BodyType<ResendCustomerWelcomeEmailBodyDto>
    export type ApiResendWelcomeEmailMutationError = ErrorType<BackendErrorEntity>

    /**
 * @deprecated
 * @summary Deprecated: Use POST /auth/sendOtp instead
 */
export const useApiResendWelcomeEmail = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiResendWelcomeEmail>>, TError,{data: BodyType<ResendCustomerWelcomeEmailBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiResendWelcomeEmail>>,
        TError,
        {data: BodyType<ResendCustomerWelcomeEmailBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiResendWelcomeEmailMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @deprecated
 * @summary Deprecated: Use POST /auth/verifyOtp instead
 */
export const apiVerifyUserEmail = (
    params: MaybeRef<ApiVerifyUserEmailParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<VerifyUserEmailResponseDto>(
      {url: `/auth/verify`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiVerifyUserEmailQueryKey = (params: MaybeRef<ApiVerifyUserEmailParams>,) => {
    return ['auth','verify', ...(params ? [params]: [])] as const;
    }

    
export const getApiVerifyUserEmailQueryOptions = <TData = Awaited<ReturnType<typeof apiVerifyUserEmail>>, TError = ErrorType<BackendErrorEntity>>(params: MaybeRef<ApiVerifyUserEmailParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiVerifyUserEmail>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiVerifyUserEmailQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiVerifyUserEmail>>> = () => apiVerifyUserEmail(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiVerifyUserEmail>>, TError, TData> 
}

export type ApiVerifyUserEmailQueryResult = NonNullable<Awaited<ReturnType<typeof apiVerifyUserEmail>>>
export type ApiVerifyUserEmailQueryError = ErrorType<BackendErrorEntity>


/**
 * @deprecated
 * @summary Deprecated: Use POST /auth/verifyOtp instead
 */

export function useApiVerifyUserEmail<TData = Awaited<ReturnType<typeof apiVerifyUserEmail>>, TError = ErrorType<BackendErrorEntity>>(
 params: MaybeRef<ApiVerifyUserEmailParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiVerifyUserEmail>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiVerifyUserEmailQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiUserSignUp = (
    userSignupBodyDto: MaybeRef<UserSignupBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      userSignupBodyDto = unref(userSignupBodyDto);
      
      return fetchApiInstance<UserEntity>(
      {url: `/auth/userSignup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userSignupBodyDto
    },
      options);
    }
  


export const getApiUserSignUpMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUserSignUp>>, TError,{data: BodyType<UserSignupBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUserSignUp>>, TError,{data: BodyType<UserSignupBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUserSignUp>>, {data: BodyType<UserSignupBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiUserSignUp(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUserSignUpMutationResult = NonNullable<Awaited<ReturnType<typeof apiUserSignUp>>>
    export type ApiUserSignUpMutationBody = BodyType<UserSignupBodyDto>
    export type ApiUserSignUpMutationError = ErrorType<BackendErrorEntity>

    export const useApiUserSignUp = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUserSignUp>>, TError,{data: BodyType<UserSignupBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUserSignUp>>,
        TError,
        {data: BodyType<UserSignupBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUserSignUpMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiAuthOtpLogin = (
    otpDto: MaybeRef<OtpDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      otpDto = unref(otpDto);
      
      return fetchApiInstance<LoginEntity>(
      {url: `/auth/admin/otp`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: otpDto
    },
      options);
    }
  


export const getApiAuthOtpLoginMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAuthOtpLogin>>, TError,{data: BodyType<OtpDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAuthOtpLogin>>, TError,{data: BodyType<OtpDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAuthOtpLogin>>, {data: BodyType<OtpDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiAuthOtpLogin(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAuthOtpLoginMutationResult = NonNullable<Awaited<ReturnType<typeof apiAuthOtpLogin>>>
    export type ApiAuthOtpLoginMutationBody = BodyType<OtpDto>
    export type ApiAuthOtpLoginMutationError = ErrorType<BackendErrorEntity>

    export const useApiAuthOtpLogin = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAuthOtpLogin>>, TError,{data: BodyType<OtpDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiAuthOtpLogin>>,
        TError,
        {data: BodyType<OtpDto>},
        TContext
      > => {

      const mutationOptions = getApiAuthOtpLoginMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiAdminSendUserOtp = (
    sendUserOtpBodyDto: MaybeRef<SendUserOtpBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      sendUserOtpBodyDto = unref(sendUserOtpBodyDto);
      
      return fetchApiInstance<void>(
      {url: `/auth/admin/sendOtp`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendUserOtpBodyDto
    },
      options);
    }
  


export const getApiAdminSendUserOtpMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminSendUserOtp>>, TError,{data: BodyType<SendUserOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminSendUserOtp>>, TError,{data: BodyType<SendUserOtpBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminSendUserOtp>>, {data: BodyType<SendUserOtpBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminSendUserOtp(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminSendUserOtpMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminSendUserOtp>>>
    export type ApiAdminSendUserOtpMutationBody = BodyType<SendUserOtpBodyDto>
    export type ApiAdminSendUserOtpMutationError = ErrorType<BackendErrorEntity>

    export const useApiAdminSendUserOtp = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminSendUserOtp>>, TError,{data: BodyType<SendUserOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiAdminSendUserOtp>>,
        TError,
        {data: BodyType<SendUserOtpBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiAdminSendUserOtpMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiVerifyOtp = (
    verifyUserOtpBodyDto: MaybeRef<VerifyUserOtpBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      verifyUserOtpBodyDto = unref(verifyUserOtpBodyDto);
      
      return fetchApiInstance<LoginEntity>(
      {url: `/auth/verifyOtp`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyUserOtpBodyDto
    },
      options);
    }
  


export const getApiVerifyOtpMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiVerifyOtp>>, TError,{data: BodyType<VerifyUserOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiVerifyOtp>>, TError,{data: BodyType<VerifyUserOtpBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiVerifyOtp>>, {data: BodyType<VerifyUserOtpBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiVerifyOtp(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiVerifyOtpMutationResult = NonNullable<Awaited<ReturnType<typeof apiVerifyOtp>>>
    export type ApiVerifyOtpMutationBody = BodyType<VerifyUserOtpBodyDto>
    export type ApiVerifyOtpMutationError = ErrorType<BackendErrorEntity>

    export const useApiVerifyOtp = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiVerifyOtp>>, TError,{data: BodyType<VerifyUserOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiVerifyOtp>>,
        TError,
        {data: BodyType<VerifyUserOtpBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiVerifyOtpMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiSendOtp = (
    sendUserOtpBodyDto: MaybeRef<SendUserOtpBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      sendUserOtpBodyDto = unref(sendUserOtpBodyDto);
      
      return fetchApiInstance<void>(
      {url: `/auth/sendOtp`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendUserOtpBodyDto
    },
      options);
    }
  


export const getApiSendOtpMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSendOtp>>, TError,{data: BodyType<SendUserOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiSendOtp>>, TError,{data: BodyType<SendUserOtpBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiSendOtp>>, {data: BodyType<SendUserOtpBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiSendOtp(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiSendOtpMutationResult = NonNullable<Awaited<ReturnType<typeof apiSendOtp>>>
    export type ApiSendOtpMutationBody = BodyType<SendUserOtpBodyDto>
    export type ApiSendOtpMutationError = ErrorType<BackendErrorEntity>

    export const useApiSendOtp = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSendOtp>>, TError,{data: BodyType<SendUserOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiSendOtp>>,
        TError,
        {data: BodyType<SendUserOtpBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiSendOtpMutationOptions(options);

      return useMutation(mutationOptions);
    }
    